import { Dropdown as FluentDropdown } from "@fluentui/web-components";
/**
 * Dropdown
 * @summary A Fabric UI Dropdown component that provides a list of options for users to choose from, with support for single or multiple selections, and customizable appearance and size.
 *
 * @example
 * ```html
 * <fabric-dropdown appearance="outline" size="medium" placeholder="Select an option">
 *   <fluent-listbox slot="listbox">
 *     <fluent-option value="option1">Option 1</fluent-option>
 *     <fluent-option value="option2">Option 2</fluent-option>
 *     <fluent-option value="option3">Option 3</fluent-option>
 *   </fluent-listbox>
 *   <span slot="indicator">▼</span>
 * </fabric-dropdown>
 * ```
 *
 * @attr {DropdownAppearance | undefined} appearance - The appearance of the dropdown.
 * @attr {DropdownSize | undefined} size - The size of the dropdown.
 * @attr {string} aria-labelledby - The `aria-labelledby` attribute value of the dropdown.
 * @attr {boolean} disabled - The disabled state of the dropdown.
 * @attr {string} id - Sets the listbox ID to a unique value if one is not provided.
 * @attr {string} value - The value of the selected option.
 * @attr {string} name - The name of the dropdown.
 * @attr {string} placeholder - The placeholder text of the dropdown.
 * @attr {DropdownType | undefined} type - The dropdown type.
 *
 * @prop {DropdownAppearance | undefined} appearance - The appearance of the dropdown.
 * @prop {DropdownSize | undefined} size - The size of the dropdown.
 * @prop {string} ariaLabelledBy - The `aria-labelledby` attribute value of the dropdown.
 * @prop {boolean} disabled - The disabled state of the dropdown.
 * @prop {string} id - Sets the listbox ID to a unique value if one is not provided.
 * @prop {string} value - The value of the selected option.
 * @prop {string} name - The name of the dropdown.
 * @prop {string} placeholder - The placeholder text of the dropdown.
 * @prop {DropdownType | undefined} type - The dropdown type.
 *
 * @slot - The default slot. Accepts a {@link (Listbox:class)} element.
 * @slot indicator - The indicator slot.
 * @slot control - The control slot. This slot is automatically populated and should not be manually manipulated.
 *
 * @csspart control - The dropdown control container.
 * @csspart indicator - The dropdown indicator.
 *
 * @method disabledChanged - Updates the disabled state of the options when the disabled property changes.
 * @method nameChanged - Updates the name of the options when the name property changes.
 * @method changeHandler - Handles the change events for the dropdown.
 * @method checkValidity - Checks the validity of the element and returns the result.
 * @method clickHandler - Handles the click events for the dropdown.
 * @method inputHandler - Handles the input events for the dropdown from the control element.
 * @method insertControl - Inserts the control element based on the dropdown type.
 * @method keydownHandler - Handles the keydown events for the dropdown.
 * @method reportValidity - Reports the validity of the element.
 * @method selectOption - Selects an option by index.
 *
 * @extends FluentDropdown
 * @tagname fabric-dropdown
 * @public
 */
export class Dropdown extends FluentDropdown {
}
//# sourceMappingURL=dropdown.js.map